// List action for creating entity
export default class {
  constructor({ root, entity_type }) {
    this.root = root;
    this.entity_type = entity_type;
  }
  async execute() {
    console.log("createAction", this.entity_type);
    this.root.$router.push({
      name: "entity_create",
      params: { type: this.entity_type }
    });
  }
}
